import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Card, Form, Button, Modal, InputGroup } from 'react-bootstrap'
import ShimmerEmpPd from '../Pages/Shimmer/ShimmerEmpPd';
import job5 from '../images/jobs/comp5.webp'
import moment from 'moment';
import { fetchJobData, fetchPlacementDrives, getAllJobs } from '../../features/constants/apis'
// import EmpPlacementDrivesDetails from './EmpPlacementDrivesDetail';
import { connect } from 'react-redux';
import { GoDotFill } from 'react-icons/go';
import PlacementDriveCard from './Cards/PlacementDriveCard';
import { FaArrowLeft } from 'react-icons/fa';
import SampleDriveImg from '../images/candidate-login/sample.jpg';

const EmpPlacementDrives = ({ authToken, userData, role, fullName, ID }) => {

    // const [show, setShow] = useState(false);
    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);

    // console.log(ID)

    const [placementDrives, setPlacementDrives] = useState([]);
    const [pdJobs, setPdJobs] = useState([])
    const [filteredPD, setFilteredPD] = useState([])

    const navigate = useNavigate();
    // const [selectedDrive, setSelectedDrive] = useState(null);

    const handleViewDriveDetails = (drive) => {
        // setSelectedDrive(drive);
        navigate(`/emp-placement-drive-details?drive=${drive}`)
    }

    const handleViewNewDriveForm = () => {
        navigate(`/new-placement-drive-form`)
    }

    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchPlacementDrives(authToken);
            console.log("data: ", data);

            console.log(authToken)
            setPlacementDrives(data.data);
            setFilteredPD(data.data.filter(drive => drive.EmployerID === ID))
            console.log(data.data.filter(drive => drive.EmployerID === ID))
        }
        fetchData();
    }, [authToken])

    console.log(filteredPD)
    console.log(placementDrives)

    console.log("filteredPD: ", filteredPD)
    console.log("image check: ", filteredPD?.Image)
    filteredPD?.forEach((item, index) => {
        console.log(`Item ${index} Image: `, item.Image);
    });
    return (
        <div id="appCapsule">


            {/* PD new UI start */}
            <div class="container">
                <div class="d-flex justify-content-between align-items-center mt-2 mb-2">
                    <h1 className="title mb-0">Placement Drive</h1>
                    <div>
                        {(role === 'Employer' || role === 'Admin') &&
                            <>
                                <Button className='add-btn btn-secondary' variant="primary" onClick={handleViewNewDriveForm}>Add Placemnet Drive</Button>
                            </>
                        }
                    </div>
                </div>
                <div class="row">
                    {placementDrives?.map((v, k) => {
                        return (
                            <div class="col-12 col-md-4 mb-2">
                                <div class="card shadow" style={{ borderRadius: '12px' }}>
                                    <div class="card-body p-0">
                                        <div style={{ backgroundImage: `url(${v.Image})`, height: '180px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', backgroundPosition: 'center', backgroundSize: 'cover' }}>
                                        </div>
                                        <div class="d-flex justify-content-center">
                                            <div class="d-flex justify-content-between gap-2">
                                                <div class="d-flex align-items-center justify-content-center text-nowrap text-secondary" style={{ marginTop: '-20px', backgroundColor: '#f1fcf5', fontSize: '12px', borderRadius: '5px', flexGrow: 1, boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.04)', height: 'fit-content', padding: '3px' }}>
                                                    <span class="d-flex" style={{ color: '#25BF5B' }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-receipt-indian-rupee"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" /><path d="M8 7h8" /><path d="M12 17.5 8 15h1a4 4 0 0 0 0-8" /><path d="M8 11h8" /></svg>
                                                        &nbsp;{v.AvgPackage}
                                                    </span>&nbsp;Avg Package
                                                </div>
                                                <div class="d-flex align-items-center justify-content-center text-nowrap text-secondary" style={{ marginTop: '-20px', backgroundColor: '#f1fcf5', fontSize: '12px', borderRadius: '5px', flexGrow: 1, boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.04)', height: 'fit-content', padding: '3px' }}>
                                                    <span class="d-flex" style={{ color: '#4B7BFF' }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-building-2"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" /><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" /><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" /><path d="M10 6h4" /><path d="M10 10h4" /><path d="M10 14h4" /><path d="M10 18h4" /></svg>
                                                        &nbsp; &nbsp;{v.Openings}
                                                    </span>
                                                    &nbsp; &nbsp;placements
                                                </div>
                                            </div>
                                        </div>
                                        <div class="m-2">
                                            <ul class="p-0 d-flex gap-2 mt-1 mb-2" style={{ listStyleType: 'none', overflow: 'hidden' }}>
                                                <li class="text-secondary text-nowrap" style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>Eligibility:</li>
                                                {v?.Skills && v.Skills.length > 0 ? (
                                                    v.Skills.map((skill, index) => (
                                                        <li key={index}>
                                                            <span className="d-flex align-items-center text-nowrap" style={{
                                                                backgroundColor: '#f5f5f5',
                                                                fontSize: '12px',
                                                                borderRadius: '50px',
                                                                height: '25px',
                                                                padding: '5px'
                                                            }}>
                                                                {skill}
                                                            </span>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li>
                                                        <span className="text-muted" style={{ fontSize: '12px' }}>No skills listed</span>
                                                    </li>
                                                )}
                                                {/* <li>
                                                    <span class="d-flex align-items-center text-nowrap" style={{ backgroundColor: '#f5f5f5', fontSize: '12px', borderRadius: '50px', height: '25px', padding: '5px' }}>Miro</span>
                                                </li>
                                                <li>
                                                    <span class="d-flex align-items-center text-nowrap" style={{ backgroundColor: '#f5f5f5', fontSize: '12px', borderRadius: '50px', height: '25px', padding: '5px' }}>Illustrator</span>
                                                </li>
                                                <li>
                                                    <span class="d-flex align-items-center text-nowrap" style={{ backgroundColor: '#f5f5f5', fontSize: '12px', borderRadius: '50px', height: '25px', padding: '5px', textOverflow: 'ellipsis' }}>Photoshop</span>
                                                </li> */}
                                            </ul>
                                            <div class="mt-1">
                                                <h3 class="fw-bold mb-0" style={{ fontSize: '22px' }}>{v.Title ? v.Title : "Title not available"}</h3>
                                                <p class="text-secondary" style={{ fontSize: '13px' }}>{v.SubTitle ? v.SubTitle : "N/A"}</p>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="d-flex align-items-center fw-bold" style={{ color: '#358D77', fontSize: '15px' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-graduation-cap-icon lucide-graduation-cap"><path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"/><path d="M22 10v6"/><path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"/></svg>&nbsp;
                                                    {v.Qualification}
                                                </div>
                                                <div>
                                                    <div class="btn btn-sm bg-primary text-white text-nowrap cursor-pointer" onClick={() => navigate(`/drive-detail?ID=${v.ID}`)}
                                                        style={{ borderRadius: '6px' }}>View</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            {/* PD new UI end */}



            {/* Placement Drive Card Starts */}
            <div className="d-none section mb-2 mt-2 full">
                <div className="container pb-2">
                    <Link to="/" type="submit" className='my-2 text-white'>
                        <Button variant="primary mb-2">
                            <FaArrowLeft style={{ width: '15px', height: '15px', marginRight: "7px" }} />Go to Dashboard
                        </Button>
                    </Link>
                    <div className='d-flex justify-content-between'>
                        <h1 className='text-primary'>Current Placement Drives</h1>
                        {(role === 'Employer' || role === 'Admin') &&
                            <>
                                <Button className='add-btn btn-secondary' variant="primary" onClick={handleViewNewDriveForm}>Add</Button>
                            </>
                        }
                    </div>

                    <div className="ms-05">
                        {(role === 'Employer' || role === 'Admin') &&
                            filteredPD.length === 0 ? (
                            filteredPD !== null ? (
                                <ShimmerEmpPd />
                            ) : (
                                <div> No Placement Drive Found</div>
                            )
                        ) : (
                            <Row xs={1} md={2} className="g-4">
                                {(role === 'Employer' || role === 'Admin') && filteredPD.length > 0 && (
                                    filteredPD.map((drive, idx) => (
                                        drive.length === 0 ? <p>No Placement Drive Found</p> :
                                            <Col key={idx} xs={12} md={6} lg={6}>
                                                <PlacementDriveCard drive={drive} handleViewDriveDetails={handleViewDriveDetails} />
                                            </Col>
                                    ))
                                )}
                            </Row>
                        )
                        }
                        {role === 'Candidate' &&
                            placementDrives.length === 0 ? (
                            placementDrives !== null ? (
                                <ShimmerEmpPd />
                            ) : (
                                <div></div>
                            )
                        ) : (
                            <Row xs={1} md={2} className="g-4 mt-2">
                                {role === 'Candidate' && placementDrives.length > 0 &&
                                    placementDrives.map((drive, idx) => (
                                        <Col key={idx} xs={12} md={6} lg={6}>
                                            <PlacementDriveCard drive={drive} handleViewDriveDetails={handleViewDriveDetails} />
                                        </Col>
                                    ))
                                }
                            </Row>
                        )
                        }
                        {/* <Row xs={1} md={2} className="g-4">
                        {role === 'Candidate' && placementDrives.length > 0 &&
                                        placementDrives.map((drive, idx) => (
                                            <Col key={idx} xs={12} md={6} lg={6}>
                                                <PlacementDriveCard drive={drive} handleViewDriveDetails={handleViewDriveDetails} />
                                            </Col>
                                        ))
                                    }
                                    </Row> */}
                    </div>

                    {/* condition for shimmer effect */}
                    {/* {placementDrives.length === null && <ShimmerEmpPd />} */}
                </div>
            </div>
            {/* Placement Drive Card Ends */}

        </div >
    )
}

const mapStateToProps = ({ auth }) => {
    const { userData, role, fullName, ID, authToken } = auth

    return {
        userData,
        role,
        fullName,
        ID,
        authToken
    }
}

export default connect(mapStateToProps)(EmpPlacementDrives)
